class ExtendableError extends Error {
  constructor(message?: string) {
    super(message); // 'Error' breaks prototype chain here
    Object.setPrototypeOf(this, new.target.prototype); // restore prototype chain
  }
}

export class UnreachableError extends ExtendableError {
  constructor(arg: never) {
    super('Unreachable error');
  }
}

export class HTTPResponseError extends ExtendableError {
  public status: number;
  public statusText: string;

  constructor(response: Response) {
    super('HTTP response error');
    this.status = response.status;
    this.statusText = response.statusText;
  }
}

export class HTTPConnectionError extends ExtendableError {
  constructor() {
    super('HTTP connection error');
  }
}

export class EmailAlreadyInUseError extends ExtendableError {
  constructor() {
    super('Email already in use');
  }
}

export class EmailNotFoundError extends ExtendableError {
  constructor() {
    super('Email not found');
  }
}

export class DomainAlreadyInUseError extends ExtendableError {
  constructor() {
    super('Domain already in use');
  }
}

export class PassworMatchLoginError extends ExtendableError {
  constructor() {
    super('Password match login');
  }
}

export class WrongPasswordError extends ExtendableError {
  constructor() {
    super('Wrong password');
  }
}

export class CaptchaError extends ExtendableError {
  constructor() {
    super('Recaptcha error');
  }
}

export class NotImplementedError extends ExtendableError {
  constructor() {
    super('Not implemented error');
  }
}

export class UnauthorizedError extends ExtendableError {
  constructor() {
    super('Unauthorized error');
  }
}

export class ForbiddenError extends ExtendableError {
  constructor() {
    super('Forbidden error');
  }
}

export class TokenExpirationError extends ExtendableError {
  constructor() {
    super('Token is expired');
  }
}

export class InvalidDomainNameError extends ExtendableError {
  constructor() {
    super('Invalid domain name');
  }
}

export class TransactionNotFoundError extends ExtendableError {
  constructor() {
    super('Transaction not found');
  }
}

export class PartnerNotFoundError extends ExtendableError {
  constructor() {
    super('Partner not found');
  }
}

export class TariffUpdateError extends ExtendableError {
  constructor() {
    super('Failed to update not allowed');
  }
}

export class AdminSiteIsNotRespondingError extends ExtendableError {
  constructor() {
    super('Admin site is not responding');
  }
}

export class OutOfResourcesError extends ExtendableError {
  constructor() {
    super('Failed to perform operation');
  }
}

export class RefundAmountExceedsTheBalance extends ExtendableError {
  constructor() {
    super('Amount exceeds the balance');
  }
}

export class MissingClientRequisites extends ExtendableError {
  constructor() {
    super('Missing client requisites');
  }
}

export class PromocodeNotFoundError extends ExtendableError {
  constructor() {
    super('Promocode not found');
  }
}

export class PromocodeAlreadyActivatedError extends ExtendableError {
  constructor() {
    super('Promocode already activated');
  }
}

export class MaximumAllowedFileSizeExceededError extends Error {
  constructor(file: File, maxSize: number) {
    super();

    this.name = `Maximum allowed file size exceeded ${file.size} > ${maxSize}`;
  }
}

export class ImageSizeViolationError extends Error {
  name = 'Image size violation';
}

export class InvalidEmailVerificationCodeError extends ExtendableError {
  name: string = 'Invalid email verification code';
}

export class UnexpectedError extends Error {
  name: string = 'Unexpected Error';
}

export class RewardAmountExceedsTheBalance extends Error {
  name: string = 'Reward amount exceeds the balance';
}

export class UserNotFoundError extends Error {
  name: string = 'User not found';
}

export class ClientSubscriptionIsCancelledError extends Error {
  name: string = 'Client subscription is cancelled';
}
